import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {Group} from '../../graphql/groups.datatypes';
import {
    gqlGroupMember,
    gqlGroupOption,
    gqlGroupOptionDetails,
    gqlGroupOptionOptionConditionsDetails
} from './getGroupMember.api';

interface GroupData {
    groupByRef: void
    group: Group
}

export const gqlGroupDates = `
    start_date
    end_date
`;

export const gqlGroupDateAdditionals = `
    start_date_additional
    end_date_additional
`;

export const gqlGroup = `
    id
    tour_resource_id
    hotel_resource_id
    name
    description
    description_resort
    description_whats_included
    description_checkin
    editing_level
    ${gqlGroupDates}
    ${gqlGroupDateAdditionals}
    max_additional_nights
    booking_form_url
    invoice_document_id
    convenience_fee
    credit_card_fee
    comp_dollar_value
    comp_ratio
    comp_dollar_estimate
    comp_final_value
    admissions_cutoff
    default_authorize_members
    validated
    disabled
    locked
    booking_tool_edit_cutoff
    description_insurance

    hasPrimaryLeader
    hasLeader
    cost
    outstandingBalance
    overduePayments
    totalCreditCardFees

    payment_schedule {
        id
    }

    tour {
      id
      internal_name
      display_name
      available_from
      available_to
      comms_email_address

      tour_roles {
        id
        tour_resource_id
        tour_role
        age_lower_bound
        age_upper_bound
      }
    }

    hotel {
      id
      internal_name
      display_name

      resource_banks {
        unit_price
      }

      roomResources {
        id
        internal_name
        guest_capacity

        resource_banks {
            capacity
            date
        }
      }
    }

    members {
      ${gqlGroupMember}
    }

    associatedUsers {
      id
      email
      first_name
      last_name
    }

    options {
      ${gqlGroupOption}
    }

    optionIds

    bookings {
        id

        roomParties {
            id
            hotel_resource_id

            hotel {
                id
                internal_name
                display_name

                roomResources {
                    id
                    internal_name
                    display_name
                }
            }

            roomResource {
                id
                room_resource_id
            }

            members {
                id
            }
        }
    }

    documents {
        id
        title

        completed_documents {
            id
        }
    }
`;

export const gqlGroupRoomPartyOptions = `
    id
    ${gqlGroupDates}

    options {
      ${gqlGroupOptionDetails}

      option {
        id
        internal_name
        is_admin_only

        resource {
            id
            consumable
            resource_banks {
                id
                remaining
            }
        }
      }
    }
`;

export const GET_GROUP_QUERY = gql`
    query getGroup($id: Int!){
        group(id: $id){
            ${gqlGroup}
        }
    }
`;

export const getGroup = (groupId: number | null) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupData>(
        GET_GROUP_QUERY,
        {
            variables: {id},

        }
    );
};

export default getGroup;
